export const symbolIncludes = (value: string): boolean => {
  if (value.match(/[!"#$%&'()*+\-.,/:;<=>?@[\\\]^_`{|}~]/u)) {
    return true;
  }

  return false;
};
